import React, { useState, useEffect, useMemo, SyntheticEvent } from "react";
import {
  Button,
  Checkbox,
  DropdownProps,
  Form,
  Label,
  Message,
  Modal,
  Popup,
} from "semantic-ui-react";

import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import EmployeeToken from "react-lib/apps/common/EmployeeToken";

import SnackMessage from "react-lib/apps/common/SnackMessage";
import CardOPDOrderSummaryUX from "./CardOPDOrderSummaryUX";
import ModNursePerformOrderUX from "./ModNursePerformOrderUX";
import htmlParse from "html-react-parser";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import SubDrugNameFormat from "react-lib/apps/HISV3/common/SubDrugNameFormat";

import { useIntl } from "react-intl";

const STATUS_COLORS: Record<string, string> = {
  CANCEL: "#7f7f7f",
  PENDING: "#ffa500",
  PERFORMED: "#008000",
};

const CARD_OPD_SUMMARY = "cardOPDOrderSummary";

const CardOPDOrderSummary = (props: any) => {
  const intl = useIntl();
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [oneDayCancelReason, setOneDayCancelReason] = useState<string>("");
  const [selectedOrderSummary, setSelectedOrderSummary] = useState<any[]>([]);

  useEffect(() => {
    props.onEvent({
      message: "HandleOPDOrderSummary",
      params: { action: "search", card: CARD_OPD_SUMMARY },
    });
  }, []);

  useEffect(() => {
    setSelectedOrderSummary([]);
  }, [props.orderSummaryOPDList]);

  const handleOnCheckedChange =
    (name: string) =>
    (e: any, { checked }: any) => {
      if (name === "isOrder") {
        props.setProp(`orderSummaryOPDFilter`, {
          ...props.orderSummaryOPDFilter,
          isOrder: checked,
          ...(!checked ? { order: null } : {}),
        });
      } else {
        props.setProp(`orderSummaryOPDFilter.${name}`, checked);
      }
    };

  const handleDeleteOPDOrderSummary = (item: any) => {
    setSelectedOrder(item);
  };

  const orderItems = useMemo(() => {
    return (props.orderSummaryOPDList || [])?.map((item: any, index: number) => {
      let orderStatus = item.order_status;

      // centrallaborder ต้องดูสถานะ report ถึงจะแสดงแถบสีเขียว
      if (item.specific_type_model_name === "centrallaborder") {
        if (item.order_status === "PERFORMED") {
          orderStatus = item.specific_status === "REPORTED" ? "PERFORMED" : "PENDING";
        }
      }

      const background = STATUS_COLORS[orderStatus] || "";

      return {
        ...item,
        check: (
          <div style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
            <Checkbox
              checked={selectedOrderSummary.includes(item.id)}
              disabled={item.order_ack_by_name}
              onChange={(e: any, v: any) => {
                if (v.checked) {
                  setSelectedOrderSummary([...selectedOrderSummary, item.id]);
                } else {
                  let newData = selectedOrderSummary.filter((key: any) => key !== item.id);
                  setSelectedOrderSummary(newData);
                }
              }}
            />
          </div>
        ),
        order_time: (
          <div
            id={`CardOPDOrderSummary-Table-Item-Time-${index}`}
            style={{ height: "100%", width: "100%", padding: "5px" }}
          >
            {item.order_time}
          </div>
        ),
        order_ack_time: (
          <div
            id={`CardOPDOrderSummary-Table-Item-AckTime-${index}`}
            style={{ height: "100%", width: "100%", padding: "5px" }}
          >
            {item.order_ack_time}
          </div>
        ),
        order_ack_by_name: (
          <div
            id={`CardOPDOrderSummary-Table-Item-AckName-${index}`}
            style={{ height: "100%", width: "100%", padding: "5px" }}
          >
            {item.order_ack_by_name}
          </div>
        ),
        detail: (
          <div
            id={`CardOPDOrderSummary-Table-Item-Detail-${index}`}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div
              style={{
                height: "100%",
                width: "100%",
                padding: "5px",
                textAlign: "left",
              }}
            >
              {orderStatus === "CANCEL" ? (
                <del>
                  {item.order_summary_detail_list.map((i: any, index: number) => (
                    <div>
                      {item.specific_type_model_name.includes("drug") ? (
                        <SubDrugNameFormat
                          onEvent={props.onEvent}
                          summary={
                            typeof i === "string" ? i : i.summary_with_name_format || i.detail
                          }
                        />
                      ) : (
                        htmlParse(typeof i === "string" ? i : i.detail)
                      )}
                    </div>
                  ))}
                  {item.verbal_description && (
                    <div>
                      <span style={{ fontWeight: "bold" }}>Description:</span>{" "}
                      <span>{item.verbal_description}</span>
                    </div>
                  )}
                </del>
              ) : (
                <>
                  {item.order_summary_detail_list.map((i: any, index: number) => (
                    <>
                      <div style={{ display: "flex" }}>
                        {i.to_be_performer_name && (
                          <Label basic color="blue" style={{ marginRight: "10px", height: "30px" }}>
                            {i.to_be_performer_name}
                          </Label>
                        )}
                        <div>
                          {item.specific_type_model_name.includes("drug") ? (
                            <SubDrugNameFormat
                              onEvent={props.onEvent}
                              summary={
                                typeof i === "string" ? i : i.summary_with_name_format || i.detail
                              }
                            />
                          ) : (
                            htmlParse(typeof i === "string" ? i : i.detail)
                          )}
                        </div>
                      </div>
                      {i?.order_detail && (
                        <div style={{ color: "gray" }}>
                          <b>{intl.formatMessage({ id: "รายละเอียดเพิ่มเติม :" })}</b>
                          {i.order_detail}
                        </div>
                      )}
                      {i?.equipment_detail && (
                        <div style={{ color: "gray" }}>
                          <b>{intl.formatMessage({ id: "อุปกรณ์ :" })}</b>
                          {i.equipment_detail}
                        </div>
                      )}
                    </>
                  ))}
                  {item.verbal_description && (
                    <div>
                      <span style={{ fontWeight: "bold" }}>Description:</span>{" "}
                      <span>{item.verbal_description}</span>
                    </div>
                  )}
                </>
              )}
            </div>
            {item.order_type_name !== "DIRECT" && (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  padding: "5px",
                  textAlign: "right",
                }}
              >
                <Popup 
                  content={
                    <>
                      <label style={{fontWeight: "bold"}}>ผู้บันทึกรับคำสั่ง</label>
                      <br/>
                      {item?.order_receive_by_name || ""}
                    </>
                  }
                  trigger={
                    <Label color={item?.order_approve_time ? "green" : "yellow"}>
                      {item?.order_approve_time ? "รคส. Co-signed" : "รคส."}
                    </Label>
                  } 
                  position='bottom left'
                />
              </div>
            )}
            {item.specific_type_name === "NORMAL" && item.specific_label !== "Cancel" && (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  padding: "5px",
                  textAlign: "right",
                }}
              >
                <PopupButton
                  onEvent={props.onEvent}
                  item={item}
                  django={props.django}
                  setSelectedOrder={setSelectedOrder}
                  onDeleteOPDOrderSummary={handleDeleteOPDOrderSummary}
                />
              </div>
            )}
          </div>
        ),
        status: (
          <div
            id={`CardOPDOrderSummary-Table-Item-Status-${index}`}
            style={{
              height: "100%",
              width: "100%",
              padding: "5px",
              background,
            }}
          >
            <div>{orderStatus === "PERFORMED" ? "Complete" : item.specific_label}</div>
            <div>{item.specific_order_by}</div>
          </div>
        ),
      };
    });
  }, [props.orderSummaryOPDList, props.django, selectedOrderSummary]);

  const handleOneDayCancelReasonChange = (e: any, v: any) => {
    setOneDayCancelReason(v.value as string);
  };

  const handleApproveOneDayCancel = () => {
    props.onEvent({
      message: "HandleDeleteOPDOrderSummary",
      params: {
        id: selectedOrder?.id,
        note: oneDayCancelReason,
        card: `${CARD_OPD_SUMMARY}_delete`,
        callback: (oneDayCancel: any, selectedOrder: any) => {
          setOneDayCancelReason(oneDayCancel);
          setSelectedOrder(selectedOrder);
        },
      },
    });
  };

  const handleOpenModNursePerform = (rowInfo: any, column: any) => () => {
    if (typeof column.Header === "string") {
      const isNurse = props.django?.user.role_types.includes("REGISTERED_NURSE");

      const order = props.orderSummaryOPDList?.[rowInfo?.index];

      if (!(isNurse && order)) {
        return;
      }

      props.onEvent({
        message: "HandleOPDOrderSummary",
        params: {
          action: "open",
          card: CARD_OPD_SUMMARY,
          order,
        },
      });
    }
  };

  const handleOpenModNursePerformAll = () => () => {
    const isNurse = props.django?.user.role_types.includes("REGISTERED_NURSE");

    if (!isNurse) {
      return;
    } else {
      props.onEvent({
        message: "HandleOPDOrderSummary",
        params: {
          action: "open",
          card: CARD_OPD_SUMMARY,
        },
      });
    }
  };

  const handleSelectAll = (e: any, v: any) => {
    if (v.checked) {
      let newData = (props.orderSummaryOPDList || [])
        .filter((item: any) => !item?.order_ack_by_name)
        .map((item: any) => item.id);

      setSelectedOrderSummary(newData);
    } else {
      setSelectedOrderSummary([]);
    }
  };

  const handleSaveNursePerformOrder = () => {
    props.onEvent({
      message: "HandleOPDOrderSummary",
      params: {
        action: "confirm_performed",
        card: CARD_OPD_SUMMARY,
        selectedOrderSummary: selectedOrderSummary,
        callback: () => {
          setSelectedOrderSummary([]);
        },
      },
    });
  };

  const checkOrderList = props.orderSummaryOPDList.filter((item: any) => !item.order_ack_by_name);

  console.log(CARD_OPD_SUMMARY, " props:", props);

  return (
    <>
      <SnackMessage
        id="CardOPDOrderSummary"
        onEvent={props.onEvent}
        onClose={() => {
          props.setProp(`errorMessage.${CARD_OPD_SUMMARY}`, null);
          props.setProp(`successMessage.${CARD_OPD_SUMMARY}`, null);
        }}
        error={props.errorMessage?.[CARD_OPD_SUMMARY]}
        success={props.successMessage?.[CARD_OPD_SUMMARY]}
        languageUX={props.languageUX}
      />
      <CardOPDOrderSummaryUX
        isOrder={props.orderSummaryOPDFilter?.isOrder}
        orderType={props.orderSummaryOPDFilter?.order}
        orderTypeOptions={props.orderSummaryOPDOptions}
        onOrderTypeChange={(e: any, data: any) => {
          props.setProp("orderSummaryOPDFilter.order", data.value);
        }}
        isLab={props.orderSummaryOPDFilter?.isLab}
        isTreatment={props.orderSummaryOPDFilter?.isTreatment}
        isImaging={props.orderSummaryOPDFilter?.isImaging}
        isOthers={props.orderSummaryOPDFilter?.isOthers}
        isOutPerformDiv={props.orderSummaryOPDFilter?.isOutPerformDiv}
        orderSummaryOPD={orderItems}
        orderSummaryColumns={[
          {
            Header: (
              <Checkbox
                checked={
                  selectedOrderSummary.length === checkOrderList.length && checkOrderList.length > 0
                }
                onChange={handleSelectAll}
              />
            ),
            accessor: "check",
            width: 60,
          },
          {
            Header: "Order Time",
            accessor: "order_time",
            width: 200,
          },
          {
            Header: "รายการคำสั่งแพทย์ (1 day)",
            accessor: "detail",
            width: "auto",
          },
          {
            Header: "เวลารับ",
            accessor: "order_ack_time",
            width: 200,
          },
          {
            Header: "พยาบาลผู้รับคำสั่ง",
            accessor: "order_ack_by_name",
            width: 200,
          },
          {
            Header: "สถานะ",
            accessor: "status",
            width: 200,
          },
        ]}
        onChangeChecked={handleOnCheckedChange}
        loadingSummary={props.loadingSummary}
        onCheckedAll={() => {
          props.setProp("orderSummaryOPDFilter", {
            ...props.orderSummaryOPDFilter,
            isLab: true,
            isTreatment: true,
            isImaging: true,
            isOthers: true,
            isOutPerformDiv: true,
          });
        }}
        onSearch={() => {
          props.onEvent({
            message: "HandleOPDOrderSummary",
            params: { action: "search", card: CARD_OPD_SUMMARY },
          });
        }}
        onSelectedOrder={(state: any, rowInfo: any, column: any, instance: any) => ({
          style: {
            backgroundColor:
              props.nurseOPDOrderPerformed?.selectedOrder?.id &&
              rowInfo?.original?.id === props.nurseOPDOrderPerformed?.selectedOrder?.id
                ? "#cccccc"
                : "white",
          },
          onDoubleClick: handleOpenModNursePerform(rowInfo, column),
        })}
        disabledNursePerform={selectedOrderSummary.length === 0}
        buttonNursePerform={handleOpenModNursePerformAll()}
        languageUX={props.languageUX}
      />
      <Modal
        open={props.nurseOPDOrderPerformed?.modOpen}
        onClose={() => {
          props.setProp("nurseOPDOrderPerformed.modOpen", false);
        }}
      >
        <ModNursePerformOrderUX
          selectedDate={props.nurseOPDOrderPerformed?.performedDate}
          onChangeDate={(date: string) => {
            props.setProp("nurseOPDOrderPerformed.performedDate", date);
          }}
          selectedTime={props.nurseOPDOrderPerformed?.performedTime}
          onTimeChange={(time) => {
            props.setProp("nurseOPDOrderPerformed.performedTime", time);
          }}
          onSave={handleSaveNursePerformOrder}
          // component
          employeeCode={
            <EmployeeToken
              id="CardOPDOrderSummary-EmployeeToken-Code"
              placeholder={intl.formatMessage({ id: "ระบุ code employee" })}
              onEnterToken={(code) => {
                props.onEvent({
                  message: "HandleOPDOrderSummary",
                  params: { action: "tokenize", code: code },
                });
              }}
              onClearToken={() => {
                props.setProp("nurseOPDOrderPerformed", {
                  ...props.nurseOPDOrderPerformed,
                  nurseToken: "",
                  nurseName: "",
                  nurseLoading: false,
                  nurseError: null,
                });
              }}
              error={props.nurseOPDOrderPerformed.nurseError}
              loading={props.nurseOPDOrderPerformed.nurseLoading}
              employeeName={props.nurseOPDOrderPerformed.nurseName}
            />
          }
        />
      </Modal>

      <ModConfirm
        openModal={!!selectedOrder}
        titleName={intl.formatMessage({ id: "ยืนยันการยกเลิก" })}
        content={
          <>
            {
              // @ts-ignore
              <Form>
                <Message>
                  {<div>{selectedOrder?.order_summary_detail_list?.[0]?.detail}</div>}
                </Message>
                <ErrorMessage error={props.errorMessage?.[`${CARD_OPD_SUMMARY}_delete`]} />
                <Form.Dropdown
                  id="CardOPDOrderSummary-Dropdown-CancelReason"
                  onChange={handleOneDayCancelReasonChange}
                  label={intl.formatMessage({ id: "ระบุเหตุผลในการยกเลิก" })}
                  options={[
                    { key: 1, text: "สั่งผิด", value: "สั่งผิด" },
                    {
                      key: 2,
                      text: "ต้องการเปลี่ยนรายการ",
                      value: "ต้องการเปลี่ยนรายการ",
                    },
                  ]}
                  value={oneDayCancelReason}
                  selection
                />
              </Form>
            }
          </>
        }
        onApprove={handleApproveOneDayCancel}
        onDeny={() => {
          setOneDayCancelReason("");
          setSelectedOrder(null);
          props.setProp("errorMessage", {
            ...props.errorMessage,
            [`${CARD_OPD_SUMMARY}_delete`]: null,
          });
        }}
      />
    </>
  );
};

const PopupButton = (props: any) => {
  const allowedAction = useMemo(() => {
    return props.django?.user.role_types.includes("DOCTOR");
  }, [props.django]);

  const handleDoubleClick = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <Popup
      style={{ padding: "8px" }}
      on="click"
      hideOnScroll
      position="bottom right"
      trigger={<Button icon="list" size="mini" onDoubleClick={handleDoubleClick} />}
      content={
        <div>
          <Button
            color="yellow"
            size="mini"
            disabled={!allowedAction || !!props.item?.order_ack_by_name}
            // disabled={props.item?.specific_label === "Request" && props.item?.order_ack_by_name !== null}
            onClick={() => {
              props.onEvent({
                message: "HandleEditOPDOrderSummary",
                params: {
                  orderId: props.item?.id,
                },
              });
            }}
          >
            EDIT
          </Button>
          <Button
            color="red"
            size="mini"
            disabled={!allowedAction}
            // disabled={props.item?.specific_label === "Cancel"}
            onClick={() => props.onDeleteOPDOrderSummary(props.item)}
          >
            DELETE
          </Button>
        </div>
      }
    />
  );
};

export default CardOPDOrderSummary;
